import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, ElementRef, Injector, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { DynamicBaseClass } from '../dynamic-base-class/dynamic-base-class.component';
import { isArray } from 'lodash-es';
import { interval, Observable, take, takeUntil } from 'rxjs';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  standalone: false,
  selector: 'app-dynamic-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent extends DynamicBaseClass implements OnInit, OnDestroy, AfterViewInit {

  private componentRef: ComponentRef<DynamicBaseClass>;
  @ViewChildren('children', { read: ViewContainerRef }) viewChildrenRef: QueryList<ViewContainerRef>;
  @ViewChild('tabVisibility', { static: false }) tabVisibility: ElementRef<HTMLDivElement>;
  protected label: string[] = [];
  selectedIndex: number = 0;

  tabItems: {
    label: string,
    isDeactivated: boolean,
    onActiveExecuteActions: string[],
    onDeActiveExecuteActions: string[],
    activeOnDataStoresChanged: string[],
    intervalInSecondToExecuteActions: number
  }[] = [];

  constructor(
    injector: Injector,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.config) {
      if (this.config.tabItems && isArray(this.config.tabItems) && this.config.tabItems.length > 0) {
        this.config.tabItems.forEach((item: any) => {
          this.tabItems.push({
            label: item.label,
            isDeactivated: item.deactivateCondition ? this.executeViewConditionEval(item.deactivateCondition) : false,
            onActiveExecuteActions: item.onActiveExecuteActions,
            onDeActiveExecuteActions: item.onDeActiveExecuteActions,
            activeOnDataStoresChanged: item.activeOnDataStoresChanged,
            intervalInSecondToExecuteActions: item.intervalInSecondToExecuteActions
          });

          if (item.deactivateCondition) {
            this.executeViewConditionEval(
              item.deactivateCondition,
              (c: any) => {
                this.tabItems[this.tabItems.findIndex(t => t.label === item.label)].isDeactivated = this.executeViewConditionEval(item.deactivateCondition);
              });
          }

          /* Intervall für die Ausführung von Aktionen */
          if (item.onActiveExecuteActions && item.onActiveExecuteActions.length > 0 && item.intervalInSecondToExecuteActions) {
            const intervalInSeconds = item.intervalInSecondToExecuteActions * 1000;
            this.subscription$.add(
              interval(intervalInSeconds).pipe().subscribe(() => {
                let index = this.tabItems.findIndex(t => t.label === item.label)
                if (index === this.selectedIndex && !this.isHidden(this.tabVisibility.nativeElement)) {
                  this.executeActionOnTabChange(index);
                }
              }));
          }

        });

      } else if (this.config.labels) {
        // Rückwärtskompatibilität
        this.label = this.config.labels;
      }
    }
    super.GlobalConfig();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    if (this.children) {
      //setTimeout(() => {
        this.AddComponentsFromChildren(this.viewChildrenRef, this.componentRef);
      //});
    }

    this.tabItems.forEach((item: any) => {
      if (item.onActiveExecuteActions && item.onActiveExecuteActions.length > 0 && item.activeOnDataStoresChanged && item.activeOnDataStoresChanged.length > 0) {
        (item.activeOnDataStoresChanged as string[]).forEach(dataStoreName => {
          let observable = this.dynamicUiServices.GetValueAsObservable(dataStoreName, this.storeDataChildNames);
          this.subscription$.add(
            observable.subscribe(() => {
              setTimeout(() => {
                let index = this.tabItems.findIndex(t => t.label === item.label)
                if (index === this.selectedIndex && !this.isHidden(this.tabVisibility.nativeElement)) {
                  this.executeActionOnTabChange(index);
                }
              });
            })
          );
        });
      }
    });
  }

  onTabChanged($event: MatTabChangeEvent) {
    this.executeActionOnTabChange($event.index);
  }

  executeActionOnTabChange(tabIndex: number) {
    if (this.tabItems && this.tabItems.length > 0) {
      this.tabItems.forEach((item, index) => {
        if (index === tabIndex) {
          if (item.onActiveExecuteActions && item.onActiveExecuteActions.length > 0) {
            item.onActiveExecuteActions.forEach(actionName => {
              this.executeAction(actionName, "ExecuteOnTabActivate: " + item.label);
            });
          }
        }
        else {
          if (item.onDeActiveExecuteActions && item.onDeActiveExecuteActions.length > 0) {
            item.onDeActiveExecuteActions.forEach(actionName => {
              this.executeAction(actionName, "ExecuteOnTabDeactivate: " + item.label);
            });
          }

        }
      });
    }
  }

}

